import { render, staticRenderFns } from "./product-table.vue?vue&type=template&id=536c4c54&scoped=true&"
import script from "./product-table.vue?vue&type=script&lang=js&"
export * from "./product-table.vue?vue&type=script&lang=js&"
import style0 from "./product-table.vue?vue&type=style&index=0&id=536c4c54&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536c4c54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('536c4c54')) {
      api.createRecord('536c4c54', component.options)
    } else {
      api.reload('536c4c54', component.options)
    }
    module.hot.accept("./product-table.vue?vue&type=template&id=536c4c54&scoped=true&", function () {
      api.rerender('536c4c54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/contract/product-table/product-table.vue"
export default component.exports